import { type FC } from 'react'
import {
  ClickAwayListener,
  Tooltip as MaterialTooltip,
  type TooltipProps as MaterialTooltipProps,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { type ActionProps } from './_internal/TooltipActions'
import { type DescriptionMessage } from './additionalMessage/AdditionalMessage.types'
import { type TooltipPlacement } from './Tooltip.types'
import TooltipContent from './TooltipContent'
import * as styles from './styles'

export type TooltipProps = {
  id: string
  open: boolean
  onClose: VoidFunction
  placement?: TooltipPlacement
  actions?: ActionProps[]
  withOutline?: boolean
} & DescriptionMessage &
  Omit<MaterialTooltipProps, 'content'>

const Tooltip: FC<TooltipProps> = ({
  id,
  placement = 'bottom-start',
  title,
  content,
  open,
  onClose,
  actions,
  children,
  withOutline = false,
  ...rest
}) => {
  const theme = useTheme()

  return (
    <ClickAwayListener onClickAway={onClose}>
      <MaterialTooltip
        {...rest}
        css={[withOutline && styles.outline(theme)]}
        title={
          <TooltipContent title={title} actions={actions}>
            <Typography<'div'> component="div" id={id}>
              {content}
            </Typography>
          </TooltipContent>
        }
        placement={placement}
        open={open}
        onClose={onClose}
        arrow
        PopperProps={{
          role: 'alert',
          disablePortal: true,
        }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        {children}
      </MaterialTooltip>
    </ClickAwayListener>
  )
}

export default Tooltip
